module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Bremgarten_AG-ab76622a770c576f35b7d8a294a974c4.svg";